import { AstNodeCategory, AstNodeType } from './node';
export class ArrayLiteral {
    constructor(token, elements) {
        this.token = token;
        this.elements = elements;
        this.nodeType = AstNodeType.ArrayLiteral;
        this.nodeCategory = AstNodeCategory.Expression;
    }
    get Elements() {
        return this.elements;
    }
    set Elements(val) {
        this.elements = val;
    }
    tokenLiteral() {
        return this.token.literal;
    }
    toString() {
        return `[${this.elements.map((e) => e.toString()).join(',')}]`;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXJyYXlMaXRlcmFsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi9hc3QvQXJyYXlMaXRlcmFsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE9BQU8sRUFBRSxlQUFlLEVBQUUsV0FBVyxFQUFjLE1BQU0sUUFBUSxDQUFDO0FBRWxFLE1BQU0sT0FBTyxZQUFZO0lBQ3JCLFlBQW9CLEtBQVksRUFBVSxRQUFzQjtRQUE1QyxVQUFLLEdBQUwsS0FBSyxDQUFPO1FBQVUsYUFBUSxHQUFSLFFBQVEsQ0FBYztRQUVoRSxhQUFRLEdBQWdCLFdBQVcsQ0FBQyxZQUFZLENBQUM7UUFDakQsaUJBQVksR0FBb0IsZUFBZSxDQUFDLFVBQVUsQ0FBQztJQUhRLENBQUM7SUFLcEUsSUFBSSxRQUFRO1FBQ1IsT0FBTyxJQUFJLENBQUMsUUFBUSxDQUFDO0lBQ3pCLENBQUM7SUFDRCxJQUFJLFFBQVEsQ0FBQyxHQUFHO1FBQ1osSUFBSSxDQUFDLFFBQVEsR0FBRyxHQUFHLENBQUM7SUFDeEIsQ0FBQztJQUVELFlBQVk7UUFDUixPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDO0lBQzlCLENBQUM7SUFFRCxRQUFRO1FBQ0osT0FBTyxJQUFJLElBQUksQ0FBQyxRQUFRLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUMsUUFBUSxFQUFFLENBQUMsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLEdBQUcsQ0FBQztJQUNuRSxDQUFDO0NBQ0oifQ==